import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty, cloneDeep } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import { uploadMultiPartFiles, saveOutputTemplateByType, getOutputTemplateByType } from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { RSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
} from '../../../../components/common';
import { tabelColumnExportR00501, sortR } from '../../constants';
import { getRegR00501Report, getAllRegR00501Report } from '../../actions';
import { makeGetListRegR00501, makeGetListAllRegR00501 } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;

class R00501 extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listR00501: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listR00501: props.listR00501,
      totalCount: getPageTotalCount({ ...state, items: props.listR00501 }),
    };
  }

  componentDidMount() {
    this.doGetListR00501();
    const {
      permissions: { modeGetRegR00501Report },
    } = this.props;
    if (modeGetRegR00501Report) {
      this.doGetListR00501();
      // this.doGetOutputTemplateByType();
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListR00501();
    });
  };

  onPageChange = page => {
    this.setState({ page }, () => this.doGetListR00501());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListR00501());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListR00501();
    });
  };

  doGetListR00501 = () => {
    const { filter, page, size, sorted } = this.state;
    const { getRegR00501Report } = this.props;
    const newFilter = cloneDeep(filter);

    if (newFilter.monthYear) {
      newFilter.monthYear = moment(newFilter.monthYear, 'MM-YYYY')
        .format('MMM-YYYY')
        .toUpperCase();
    }
    const payload = {
      page: page + 1,
      size,
      filter: newFilter,
      sort: !isEmpty(sorted) && sortR[sorted.sortCol] ? sortR[sorted.sortCol][sorted.sortDir] : null,
    };
    this.setState({ isSearching: true });
    getRegR00501Report(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistR00501 = cb => {
    const { filter, sorted } = this.state;
    const { getAllRegR00501Report } = this.props;
    const newFilter = cloneDeep(filter);

    if (newFilter.monthYear) {
      newFilter.monthYear = moment(newFilter.monthYear, 'MM-YYYY')
        .format('MMM-YYYY')
        .toUpperCase();
    }
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter: newFilter,
      sort: !isEmpty(sorted) ? sortR[sorted.sortCol][sorted.sortDir] : null,
    };
    getAllRegR00501Report(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistR00501(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllR00501, t } = this.props;
        convertJson2Pdf({
          data: listAllR00501,
          t,
          title: t('reportPage:sidebar.R00501').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.R00501')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistR00501(() => {
      const { listAllR00501, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'GET_REG_R005_01_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.R00501')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.R00501')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllR00501,
            t,
            columns: tableColumnsOutput,
            listOptionFields: { jobType: 'jobTypes', jobStatus: 'jobStatus' },
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllR00501,
          t,
          title: t('reportPage:sidebar.R00501').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.R00501')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.R00501')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('COMMISSIONS_COLLECTIONS_EXTRACTS', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportR00501,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listR00501,
      emails,
      filter,
      exportColumnsSave,
      isOpenModalExportConfig,
    } = this.state;
    const {
      listAllR00501,
      t,
      permissions: { modeGetRegR00501Report, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetRegR00501Report) return '';
    const exportColumns = exportColumnsSave || {};
    // tableColumnsOutput = exportColumns?.targetFields?.items || [];
    tableColumnsOutput = tabelColumnExportR00501 || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[{ name: t('label.report'), url: RouteNames.report.path }, { name: t('reportPage:sidebar.R00501') }]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.R00501')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <RSearchForm onSubmit={this.onHandleSubmitSearch} defaultFilter={filter} />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  {/* <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    <i className="ti-list" />
                  </button> */}
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.R00501').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllR00501,
                          t,
                          title: t('reportPage:sidebar.R00501').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.R00501')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listR00501}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={listR00501 && listR00501.length ? listR00501 : []}
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        {/* <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem> */}
      </div>
    );
  }
}

R00501.propTypes = {
  getRegR00501Report: PropTypes.func,
  getAllRegR00501Report: PropTypes.func,
  listAllR00501: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any), PropTypes.objectOf(PropTypes.any)]),
};

R00501.defaultProps = {
  getRegR00501Report: () => {},
  getAllRegR00501Report: () => {},
  listAllR00501: [],
};

const mapStateToProps = createStructuredSelector({
  listR00501: makeGetListRegR00501() || [],
  listAllR00501: makeGetListAllRegR00501() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getRegR00501Report,
    getAllRegR00501Report,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
  })(R00501)
);
